import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { isContentCountry } from 'globalConfigApp'
import { reduxForm } from 'redux-form'
import { vipContactForm } from 'app/validators/vip'

import { BrokerCard } from 'components'
import VipContactFormFields from './VipContactFormFields'

import CurrentOcupationMessage from './CurrentOcupationMessage'

import styles from './style'

export class VipContactForm extends Component {

  constructor(props) {
    super(props)
    this.state = {
      checkedRgpd: !isContentCountry('es_ES')
    }
  }


  static propTypes = {
    brokerData: PropTypes.object.isRequired
  }

  static defaultProps = {
    style: {}
  }

  render() {
    const { checkedRgpd } = this.state
    const {
      handleSubmit,
      invalid,
      style,
      brokerData,
      currentOcupationStatus,
      errorMessageForm
    } = this.props

    return (
      <form className="form-container" onSubmit={handleSubmit} style={style}>
        {currentOcupationStatus ? (
          <CurrentOcupationMessage currentOcupationStatus={currentOcupationStatus} />
        ) : (
          <BrokerCard
            brokerData={brokerData}
            handleRequestPhone={this.props.handleRequestPhone}
          />
        )}

        <VipContactFormFields
          invalid={invalid}
          checkedRgpd={checkedRgpd}
          handleValidRgpd={checkedRgpd => this.setState({ checkedRgpd })}
          errorMessageForm={errorMessageForm}
        />

        <style jsx>{styles}</style>
      </form>
    )
  }
}

const formConfig = {
  form: 'vipContactForm',
  validate: vipContactForm
}

export default reduxForm(formConfig)(VipContactForm)
